import React from "react";
import { TableContentForLeafCollectionSummary } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const columnNames = this.props.columnNames;
        const fieldDeductions = this.props.fieldDeductions;
        const loftDedutions = this.props.loftDedutions;

        return (
            <div>
                <h3><center><u>Loft Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>

                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <table id="pdfTable" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th colSpan={3}></th>
                                        <th colSpan={1 + fieldDeductions.length} style={{ textAlign: "center" }}>Field Weight /Kg</th>
                                        <th colSpan={1 + loftDedutions.length} style={{ textAlign: "center" }}>Loft Weight /Kg</th>
                                    </tr>
                                    <tr>
                                        {columnNames.map((x, index) => {
                                            return (
                                                <th key={index}>{x}</th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForLeafCollectionSummary
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}